interface DBConstructor {
  new (name: string, options?: Record<string, unknown>): unknown;
  plugin(plugin: unknown): void;
}

export const setupDB = async (
  BASE_URL: string,
  PouchDBConstructor: DBConstructor,
  PouchDBFind: unknown
) => {
  PouchDBConstructor.plugin(PouchDBFind);

  const Usuario = new PouchDBConstructor('Usuario');
  const Servicios = new PouchDBConstructor('servicios');
  const Horarios = new PouchDBConstructor('horariosv4');

  const ServiciosRemote = new PouchDBConstructor(`${BASE_URL}/servicios`, {
    skip_setup: true,
  });
  const HorariosRemote = new PouchDBConstructor(`${BASE_URL}/horariosv4`, {
    skip_setup: true,
  });

  const DB_API = {
    PouchDB: PouchDBConstructor,
    Usuario,
    Servicios,
    ServiciosRemote,
    Horarios,
    HorariosRemote,
  };

  return { db: DB_API };
};

export default defineNuxtPlugin({
  name: 'db',
  parallel: true,
  async setup(_nuxtApp) {
    const {
      public: { dbUrl: BASE_URL },
    } = useRuntimeConfig();

    const PouchDB = (await import('pouchdb-browser')).default;
    const PouchDBFind = (await import('pouchdb-find')).default;

    return {
      provide: await setupDB(BASE_URL, PouchDB, PouchDBFind),
    };
  },
});
